export var DEFAULT_AVATAR = "https://res.cloudinary.com/compara/image/upload/q_auto,c_pad,h_28,w_28/v1625522834/users/avatars/avatar.svg";
export var AVATAR_SIZE = 28;
export var MESSAGES_DATA = {
    logoutLink: {
        url: "/logout",
        message: "userAccountMenu.logout",
    },
    loggedMenu: {
        profile: {
            url: "/profile",
            message: "userAccountMenu.profile",
        },
    },
    unloggedMenu: {
        signIn: {
            url: "/sign-up",
            message: "userAccountMenu.signUp",
        },
        signUp: {
            url: "/sign-in",
            message: "userAccountMenu.signIn",
        },
    },
    avatarAlt: {
        message: "userAccountMenu.avatarAlt",
    },
    buttonLabel: {
        message: "userAccountMenu.buttonLabel",
    },
};
//# sourceMappingURL=constants.js.map